import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RegisterBaseComponent } from '@luggagehero/features/user';

@Component({
  selector: 'lh-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class RegisterComponent extends RegisterBaseComponent {}
